import React from 'react'
import {Helmet} from "react-helmet";
import PageTitle from '../../../pagetitle/PageTitle'
import { kurumlarArr } from "./KurumlarArr";

export default function KatilimciKurumFirmalar() {
  const title = "OKAF Katılımcı Kurum ve Firmalar - Samsun Üniversitesi";
  const description = "Samsun Üniversitesi ev sahipliğinde gerçekleşecek olan Orta Karadeniz Kariyer Fuarı (OKAF)'ın katılımcı kurum ve firmaların bilgilerine ulaşmak için tıklayınız!";
  
  return (
    <>
      <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
      </Helmet>

      <PageTitle name="Katılımcı Kurum / Firmalar"></PageTitle>
      <div className='container mt-4'>
        <div className='katilimciKurumFirmalar'>

          <div className='body'>
            <div className='title'>
              <span>Katılımcı Kurum / Firmalar</span>
            </div>
            <div className='boxs'>
              {
                kurumlarArr.map((element) => (
                  <div className='box'>
                    <div className='figure'><img src={element.img == "" ? "/assets/img/no-img.png" : element.img} alt="" /></div>
                    <div className='name'>{element.name}</div>
                  </div>
                ))
              }
            </div>
          </div>

        </div>
      </div>
    </>
  )
}